module.exports = __webpack_public_path__ + "img/fondo-cta-empresas-tablet.6d99d69.webp";